import React, { useCallback } from "react";
import { Joyride, type EventData, STATUS } from "react-joyride";
import { useWalkthrough } from "../../contexts/WalkthroughContext";
import { getWalkthroughSteps } from "./walkthroughSteps";
import { useNavigate } from "react-router-dom";

const AppWalkthrough: React.FC = () => {
  const { isTourRunning, stopTour } = useWalkthrough();
  const navigate = useNavigate();

  const handleEvent = useCallback(
    (data: EventData) => {
      const { status } = data;
      const finished = ([STATUS.FINISHED, STATUS.SKIPPED] as string[]).includes(status);
      if (finished) {
        stopTour();
      }
    },
    [stopTour]
  );

  return (
    <Joyride
      steps={getWalkthroughSteps(navigate)}
      run={isTourRunning}
      continuous
      onEvent={handleEvent}
      options={{
        primaryColor: "#fbbf24",
        backgroundColor: "#18181b",
        textColor: "#d4d4d8",
        arrowColor: "#18181b",
        showProgress: true,
        skipBeacon: true,
        buttons: ["back", "primary"],
      }}
    />
  );
};

export default AppWalkthrough;
